import React from "react";

export let AuthContext = React.createContext(null);
